module.exports = __webpack_public_path__ + "media/images/emblems/Jens-coat_of_arms-a33966ce2f76e72198a27c4739f77369.svg";